import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { LogExport } from "@interfaces/logExport.interface";
import { Machine } from "@interfaces/models/machine.interface";
import { ExportLogService } from "@services/exportLog.service";
import { MachineService } from "@services/machine.service";
import { ProtectedGridService } from "@services/protectedGrid.service";
import { SkillService } from "@services/skillService.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "skills",
	styleUrls: ["skills.css"],
	templateUrl: "skills.html"
})
export class SkillsAdminComponent {
	canExportGrid = false;
	deleteEnabled = true;
	editEnabled = true;
	gridLoading = false;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	itemType = "Skill"
	itemUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	items: any[] = [];
	machines: Machine[] = [];
	statuses: any;
	title: string;
	
	constructor(private router: Router, private toastService: ToastService, private itemService: SkillService, private exportLogService: ExportLogService, private machineService: MachineService, private protectedGridService: ProtectedGridService) {
		this.headerPrimaryButtons.push({ icon: "fal fa-plus", method: "addNewItem", text: `New ${this.itemType}` });
		this.title = `${this.itemType}s`;
		this.viewRow = this.viewRow.bind(this);
		this.editRow = this.editRow.bind(this);
		this.deleteRow = this.deleteRow.bind(this);
		this.getItems();
		this.getMachines();
		this.checkGridExportPermissions();
	}

	addNewItem() {
		this.router.navigate([`${this.itemUrl}/create`]);
	}
	
	checkGridExportPermissions() {
		this.protectedGridService.canExport("Skills")
			.subscribe(
				(res: any) => {
					this.canExportGrid = res.response;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	deleteRow(e: any) {
		const result = confirm("Are you sure you want to delete this item?");
		if(result)
		{
			this.itemService.deleteSingleById(e.row.data.id)
				.subscribe(
					() => {
						this.toastService.success(this.itemType + " deleted!");
						this.getItems();
					},
					(err) => {
						console.log(err);
						this.toastService.error("Something Went Wrong!");
					},
				);
		}
	}

	displayMachineInDropdown(e: any) { 
		return e === null || e === undefined ? "" : (e.cellNumber === null || e.cellNumber === undefined ? "???" : e.cellNumber) + " - " + e.name;
	}

	editRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.id}_edit`]);
	}

	getItems() {
		this.gridLoading = true;
		this.itemService.getAll()
			.subscribe(
				(res: any) => {
					this.items = res.response.items;
					this.gridLoading = false;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	getMachines() {
		this.machineService.getAll()
			.subscribe(
				(res: any) => this.machines = res.response.items,
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	logExport() {
		const logExport = new LogExport();
		logExport.gridName = "Skills";
		this.exportLogService.logExport(logExport)
			.subscribe(
				() => console.log("Export Logged"),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
					return false;
				},
			);
	}

	viewRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.id}`]);
	}
}